import { v4 as uuidv4 } from "uuid";
import store from 'store';

export const getDefaultReqConfig =  () => {
    const state = store.getState();
    const tenantId = state.commonData?.tenant?.tenantId;
    const applicationName = state.workSpace?.selectedAppName;
    const userId = state.commonData?.userProfile?.userId;
    const sessionId = state.commonData?.userProfile?.sessionId;
    const applicationId = state.commonData?.applicationId;
    const workspaceId = state.commonData?.workspaceId;
    let uniqueId = localStorage.getItem('uniqueId')
    if (!uniqueId) {
        uniqueId = uuidv4();
        localStorage.setItem('uniqueId', uniqueId);
      }
    const requestId = uuidv4(); // Generate a unique ID for each request
    const delimiter = ';';
    
    const requestConfig =   {
        tenantId,
        userId,
        workspaceId,
        applicationId,
        applicationName,
        sessionId,
        requestId,
        uniqueId,
        }

        const requestConfigString = Object.values(requestConfig).join(delimiter);
        return requestConfigString;
      };